export default __webpack_public_path__ + "static/media/about.f362babc.svg";